import store from "../Redux/Store";

function getSupportEmail() {
  const storeData = store.getState().storeReducer?.data;
  return storeData?.store?.constants?.support_email ?? "ecommerce@dotpe.in";
}

export const SUPPORT_EMAIL = getSupportEmail();
